export default {
  name: "turntable",
  imgDir: "assistanceHelp",
};
